import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReadonlyService {

  private isReadonly$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  set readonly(isReadonly: boolean) {
    this.isReadonly$.next(isReadonly);
  }

  getReadonly() {
    // TODO check this
    return of(false);
    //this.isReadonly$.asObservable();
  }

}
